export default "__VITE_ASSET__E$$Nwaqn__"